export function rndStr(len = 30): string {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const str: string[] = [];
  for (let i = 0; i < len; i++) {
    str.push(chars[Math.floor(Math.random() * chars.length)]);
  }
  return str.join('');
}
